import React from 'react';
import { CTALink } from '@components/CTALink';
import { Department, Overlay, DepartmentText, StyledCloudImage } from './ShopRegistrySection.styles';

interface Props {
  title: string;
  image: string;
  link: string;
  elementId?: string;
}

export const ShopRegistryDepartment: React.FC<Props> = ({ title, image, link, elementId }) => {
  return (
    <Department>
      <Overlay>
        <DepartmentText color="mono7" variant="sectionEyeBrow24" tagName="h3">
          {title}
        </DepartmentText>
      </Overlay>
      <CTALink
        id={`BabyRegistryDepartment${title}`}
        variant="altPurple"
        href={link}
        aria-label={`BabyRegistry Department ${title}`}
        target="_blank"
        data-element-id={elementId}
      >
        <StyledCloudImage src={image} width="100%" resizeWidth={326} mobileResizeWidth={326} optimization="default" />
      </CTALink>
    </Department>
  );
};
